import { AppleSignIn } from "@/auth/appleSignIn";

// Services ID (com.assistant8.web) registered in the Apple Developer portal; must
// be one of the backend APPLE_CLIENT_ID audiences. Empty in dev hides the button.
const clientId = import.meta.env.VITE_APPLE_CLIENT_ID ?? "";
// Must EXACTLY match a Return URL registered under the Services ID's Web
// Authentication config, or Apple rejects the request.
const redirectUri =
  import.meta.env.VITE_APPLE_REDIRECT_URI ??
  "https://my.assistant8.com/auth/apple/callback";

export const appleSignIn = new AppleSignIn(clientId, redirectUri);
